(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hby-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeYarnCalculators = (root = document) => {
      root.querySelectorAll('[data-yarn-calculator]').forEach((calculator) => {
        if (calculator.dataset.initialized === 'true') return;

        calculator.dataset.initialized = 'true';

        const projectSelect = calculator.querySelector('[data-project]');
        const sizeSelect = calculator.querySelector('[data-size]');
        const tensionSelect = calculator.querySelector('[data-tension]');
        const result = calculator.querySelector('[data-result]');
        const packsResult = calculator.querySelector('[data-packs]');

        if (
          !projectSelect ||
          !sizeSelect ||
          !tensionSelect ||
          !result ||
          !packsResult
        ) {
          return;
        }

        const coverage = Math.max(
          1,
          Number(calculator.dataset.coverage) || 350
        );

        const safetySkeins = Math.max(
          0,
          Number(calculator.dataset.safety) || 0
        );

        const packSize = Math.max(
          1,
          Number(calculator.dataset.packSize) || 8
        );

        const yardsPerSkein = Math.max(
          1,
          Number(calculator.dataset.yardsPerSkein) || 27
        );

        const metersPerSkein = Math.max(
          1,
          Number(calculator.dataset.metersPerSkein) || 25
        );

        const skeinsLabel =
          calculator.dataset.skeins || 'skeins';

        const packsLabel =
          calculator.dataset.packs || 'packs';

        const unavailableLabel =
          calculator.dataset.unavailable || 'Unavailable';

        const sizeKeys = ['s1', 's2', 's3', 's4', 's5'];

        const selectedProject = () => {
          return projectSelect.options[projectSelect.selectedIndex];
        };

        const selectedSize = () => {
          return sizeSelect.options[sizeSelect.selectedIndex];
        };

        const updateSizeOptions = () => {
          const project = selectedProject();

          if (!project) return;

          sizeKeys.forEach((sizeKey) => {
            const option = sizeSelect.querySelector(
              `option[value="${sizeKey}"]`
            );

            if (!option) return;

            const label = project.getAttribute(
              `data-${sizeKey}-label`
            );

            const measurementA = Number(
              project.getAttribute(`data-${sizeKey}-a`)
            );

            const measurementB = Number(
              project.getAttribute(`data-${sizeKey}-b`)
            );

            option.textContent = label || sizeKey;
            option.disabled =
              !label ||
              measurementA <= 0 ||
              measurementB <= 0;
          });

          const currentOption = selectedSize();

          if (currentOption && currentOption.disabled) {
            const firstAvailable = Array
              .from(sizeSelect.options)
              .find((option) => !option.disabled);

            if (firstAvailable) {
              sizeSelect.value = firstAvailable.value;
            }
          }
        };

        const calculateSurfaceArea = (
          type,
          measurementA,
          measurementB
        ) => {
          if (type === 'round_bed') {
            const diameter = measurementA;
            const wallHeight = measurementB;
            const radius = diameter / 2;

            const baseArea =
              Math.PI * radius * radius;

            const wallArea =
              Math.PI * diameter * wallHeight;

            return baseArea + wallArea;
          }

          return measurementA * measurementB;
        };

        const updateResult = () => {
          const project = selectedProject();
          const size = selectedSize();

          if (!project || !size) return;

          const sizeKey = size.value;

          const measurementA = Number(
            project.getAttribute(`data-${sizeKey}-a`)
          );

          const measurementB = Number(
            project.getAttribute(`data-${sizeKey}-b`)
          );

          if (
            measurementA <= 0 ||
            measurementB <= 0
          ) {
            result.textContent = unavailableLabel;
            packsResult.textContent = '';
            return;
          }

          const calculationType =
            project.dataset.type || 'flat';

          const projectAllowance = Math.max(
            1,
            Number(project.dataset.allowance) || 1
          );

          const tensionMultiplier = Math.max(
            0.5,
            Number(tensionSelect.value) || 1
          );

          const surfaceArea = calculateSurfaceArea(
            calculationType,
            measurementA,
            measurementB
          );

          const adjustedArea =
            surfaceArea *
            projectAllowance *
            tensionMultiplier;

          const skeins = Math.ceil(
            adjustedArea / coverage
          ) + safetySkeins;

          const packs = Math.ceil(
            skeins / packSize
          );

          const yards = skeins * yardsPerSkein;
          const meters = skeins * metersPerSkein;

          result.textContent =
            `${size.textContent.trim()} · ${skeins} ${skeinsLabel}`;

          packsResult.textContent =
            `${packs} ${packsLabel} · approximately ${yards} yd / ${meters} m`;
        };

        const updateProject = () => {
          updateSizeOptions();
          updateResult();
        };

        projectSelect.addEventListener(
          'change',
          updateProject
        );

        sizeSelect.addEventListener(
          'change',
          updateResult
        );

        tensionSelect.addEventListener(
          'change',
          updateResult
        );

        updateProject();
      });
    };

    const initialize = () => {
      initializeYarnCalculators(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initialize
      );
    } else {
      initialize();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeYarnCalculators(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hby-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopHover = window.matchMedia(
      '(min-width: 990px) and (hover: hover) and (pointer: fine)'
    );

    const bindHoverMenus = (root = document) => {
      root
        .querySelectorAll('.hby-desktop-nav details')
        .forEach((dropdown) => {
          if (dropdown.dataset.hbyHoverMenu === 'true') return;

          dropdown.dataset.hbyHoverMenu = 'true';

          let closeTimer;

          const openMenu = () => {
            if (!desktopHover.matches) return;

            window.clearTimeout(closeTimer);

            const navigation = dropdown.closest('.hby-desktop-nav');

            navigation
              ?.querySelectorAll('details[open]')
              .forEach((otherDropdown) => {
                if (otherDropdown !== dropdown) {
                  otherDropdown.open = false;
                }
              });

            dropdown.open = true;
          };

          const closeMenu = () => {
            if (!desktopHover.matches) return;

            closeTimer = window.setTimeout(() => {
              dropdown.open = false;
            }, 180);
          };

          dropdown.addEventListener('mouseenter', openMenu);
          dropdown.addEventListener('mouseleave', closeMenu);

          dropdown.addEventListener('focusin', () => {
            window.clearTimeout(closeTimer);
            dropdown.open = true;
          });

          dropdown.addEventListener('focusout', (event) => {
            if (!dropdown.contains(event.relatedTarget)) {
              dropdown.open = false;
            }
          });
        });
    };

    const initializeMenus = () => {
      bindHoverMenus(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeMenus);
    } else {
      initializeMenus();
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindHoverMenus(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hby-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProductCarousels = (root = document) => {
      root
        .querySelectorAll('[data-product-carousel]')
        .forEach((carousel) => {
          if (carousel.dataset.carouselInitialized === 'true') return;

          carousel.dataset.carouselInitialized = 'true';

          const slides = Array.from(
            carousel.querySelectorAll('[data-product-slide]')
          );

          const moreButton = carousel.querySelector('[data-products-more]');
          const status = carousel.querySelector('[data-products-status]');
          const pageSize = Number(carousel.dataset.pageSize) || 4;
          const pageCount = Math.ceil(slides.length / pageSize);

          let currentPage = 0;

          if (!moreButton || slides.length <= pageSize) {
            if (moreButton) {
              moreButton.hidden = true;
            }

            return;
          }

          const showPage = (page) => {
            currentPage = page;

            const firstVisibleIndex = currentPage * pageSize;
            const lastVisibleIndex = firstVisibleIndex + pageSize;

            slides.forEach((slide, index) => {
              slide.hidden = !(
                index >= firstVisibleIndex &&
                index < lastVisibleIndex
              );
            });

            if (status) {
              status.textContent =
                `第 ${currentPage + 1} 组，共 ${pageCount} 组商品`;
            }

            const firstVisibleSlide = slides[firstVisibleIndex];

            if (firstVisibleSlide) {
              firstVisibleSlide.animate(
                [
                  {
                    opacity: 0,
                    transform: 'translateX(16px)'
                  },
                  {
                    opacity: 1,
                    transform: 'translateX(0)'
                  }
                ],
                {
                  duration: 260,
                  easing: 'ease-out'
                }
              );
            }
          };

          moreButton.addEventListener('click', () => {
            const nextPage = (currentPage + 1) % pageCount;
            showPage(nextPage);
          });

          showPage(0);
        });
    };

    const initialize = () => {
      initializeProductCarousels(document);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeProductCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
